import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import nl from './locales/nl.json';

// Detect browser language or use localStorage
const savedLanguage = localStorage.getItem('language');
const browserLanguage = navigator.language.split('-')[0]; // 'en-US' -> 'en'
const defaultLanguage = savedLanguage || browserLanguage || 'nl';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    lng: defaultLanguage,
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

// Save language preference
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
